<form [formGroup]="activeService.entity">
  <div class="grid">
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="name">
          <span class="p-error">*</span>Nombre:
        </label>
        <input type="text" pInputText id="name" formControlName="name" placeholder="Tiguan 2025" />
        <ng-container *ngIf="e.get('name')?.invalid && (e.get('name')?.dirty || e.get('name')?.touched)">
          <small class="p-error" *ngIf="e.get('name')?.errors?.['required']">El nombre es obligatorio.</small>
          <small class="p-error" *ngIf="e.get('name')?.errors?.['minlength']">El nombre debe tener al menos {{e.get('name')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="provider">
          <span class="p-error">*</span>Proveedor:
        </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown formControlName="provider" [panelStyle]="{'width': '100%' }" [style]="{'height': '45px'}" scrollHeight="150px" [options]="activeService.providers" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="Selecciona un proveedor">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="e.value.provider">
                <div>{{activeService.getProviderName(e.value.provider)}}</div>
              </div>
            </ng-template>
            <ng-template let-provider pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ provider.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="category">
          <span class="p-error">*</span>Categoria:
        </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown formControlName="category" [panelStyle]="{'width': '100%' }" [style]="{'height': '45px'}" scrollHeight="150px" [options]="categories" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="Selecciona una categoria">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="e.value.category">
                <div>{{getNameCategory(e.value.category)}}</div>
              </div>
            </ng-template>
            <ng-template let-category pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ category.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <ng-container *ngIf="e.get('category')?.invalid && (e.get('category')?.dirty || e.get('category')?.touched)">
            <small class="p-error" *ngIf="e.get('category')?.errors?.['required']">La categoria es obligatoria.</small>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="brand">
          <span class="p-error">*</span>Marca:
        </label>
        <input type="text" pInputText id="brand" formControlName="brand" placeholder="Volkswagen" />
        <ng-container *ngIf="e.get('brand')?.invalid && (e.get('brand')?.dirty || e.get('brand')?.touched)">
          <small class="p-error" *ngIf="e.get('brand')?.errors?.['required']">La marca obligatoria.</small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="assetModel">
          <span class="p-error">*</span>Modelo:
        </label>
        <input type="text" pInputText id="assetModel" formControlName="assetModel" placeholder="Tiguan" />
        <ng-container *ngIf="e.get('assetModel')?.invalid && (e.get('assetModel')?.dirty || e.get('assetModel')?.touched)">
          <small class="p-error" *ngIf="e.get('assetModel')?.errors?.['required']">El modelo es obligatorio.</small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6" formGroupName="acquisition">
      <div class="field">
        <label for="total">
          <span class="p-error">*</span>Monto total:
        </label>
        <p-inputNumber
          id="total"
          formControlName="total"
          placeholder="$0.00"
          mode="currency"
          currency="MXN"
          locale="es-MX"
          (onInput)="calculateAcquisitionValues(+($event.value))"
        ></p-inputNumber>
        <ng-container *ngIf="e.get('acquisition.total')?.invalid && (e.get('acquisition.total')?.dirty || e.get('acquisition.total')?.touched)">
          <small class="p-error" *ngIf="e.get('acquisition.total')?.errors?.['required']">El monto total es obligatorio.</small>
          <small class="p-error" *ngIf="e.get('acquisition.total')?.hasError('negativeValue')">
            El monto total no puede ser negativo.
          </small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="serie">
          <span class="p-error">*</span>Serie:
        </label>
        <input type="text" pInputText id="serie" formControlName="serie" placeholder="1234AFBC" />
        <ng-container *ngIf="e.get('serie')?.invalid && (e.get('serie')?.dirty || e.get('serie')?.touched)">
          <small class="p-error" *ngIf="e.get('serie')?.errors?.['required']">La serie es obligatoria.</small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="version">
          <span class="p-error">*</span>Versión:
        </label>
        <input type="text" pInputText id="version" formControlName="version" placeholder="1234AFBC" />
        <ng-container *ngIf="e.get('version')?.invalid && (e.get('version')?.dirty || e.get('version')?.touched)">
          <small class="p-error" *ngIf="e.get('version')?.errors?.['required']">La versión es obligatoria.</small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="color">
          <span class="p-error">*</span>Color:
        </label>
        <input type="text" pInputText id="color" formControlName="color" placeholder="Rojo atintado" />
        <ng-container *ngIf="e.get('color')?.invalid && (e.get('color')?.dirty || e.get('color')?.touched)">
          <small class="p-error" *ngIf="e.get('color')?.errors?.['required']">El color es obligatorio.</small>
          <small class="p-error" *ngIf="e.get('color')?.hasError('onlyLetters')">
            Solo se permiten letras en el campo de color.
          </small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="engineNumber">Número de motor:</label>
        <input type="text" pInputText id="engineNumber" formControlName="engineNumber" placeholder="ABC-1234-DEF" />
        <ng-container *ngIf="e.get('engineNumber')?.invalid && (e.get('engineNumber')?.dirty || e.get('engineNumber')?.touched)">
          <small class="p-error" *ngIf="e.get('engineNumber')?.errors?.['required']">El número de motor es obligatorio.</small>
        </ng-container>
      </div>
    </div>

    <div class="col-12">
      <div class="field">
        <label for="description">
          <span class="p-error">*</span>Descripción:
        </label>
        <textarea rows="5" cols="30" pInputTextarea formControlName="description" id="description"></textarea>
        <ng-container *ngIf="e.get('description')?.invalid && (e.get('description')?.dirty || e.get('description')?.touched)">
          <small class="p-error" *ngIf="e.get('description')?.errors?.['required']">La descripción es obligatorio.</small>
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <div class="field-checkbox">
          <p-checkbox formControlName="isPublic" id="isPublic" [binary]="true"></p-checkbox>
          <label for="isPublic">Activo público</label>
        </div>
        <small class="p-text-secondary">Marque esta opción si el activo debe ser visible públicamente</small>
      </div>
    </div>
  </div>
</form>
